<section class="widget-section">
  <div class="container pt-5 pb-6">
    <app-close-project-form></app-close-project-form>
  </div>
</section>
